import styled from 'styled-components';
import type { VoteTally } from '@/core/models/case';
import { COUNCIL_KEEP, COUNCIL_REMOVE } from '../tones';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const Track = styled.div`
  display: flex;
  height: 6px;
  border-radius: ${({ theme }) => theme.radius.sm};
  overflow: hidden;
  background: ${({ theme }) => theme.color.glassBorder};
`;
const Keep = styled.span<{ $pct: number }>`
  width: ${({ $pct }) => $pct}%;
  background: ${COUNCIL_KEEP};
`;
const Remove = styled.span<{ $pct: number }>`
  width: ${({ $pct }) => $pct}%;
  background: ${COUNCIL_REMOVE};
`;
const Nums = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
`;

export function VoteProgressBar({ votes }: { votes: VoteTally }) {
  const total = votes.keep + votes.remove;
  const keepPct = total ? Math.round((votes.keep / total) * 100) : 0;
  const removePct = total ? 100 - keepPct : 0;
  return (
    <Wrap>
      <Track><Keep $pct={keepPct} /><Remove $pct={removePct} /></Track>
      <Nums><span>{votes.keep} keep</span><span>{votes.remove} remove</span></Nums>
    </Wrap>
  );
}
